"use strict";
import { SOCKS_CONTROLLER_ADDRESSES, Token } from "@uniswap/sdk-core";
import { useAccount } from "hooks/useAccount";
import { useTokenBalance } from "lib/hooks/useCurrencyBalance";
import { useMemo } from "react";
import { UniverseChainId } from "uniswap/src/features/chains/types";
const SOCKS = (() => {
  try {
    const mainnetChainId = UniverseChainId.Mainnet;
    if (mainnetChainId && SOCKS_CONTROLLER_ADDRESSES[mainnetChainId]) {
      return new Token(mainnetChainId, SOCKS_CONTROLLER_ADDRESSES[mainnetChainId], 0);
    }
  } catch (error) {
  }
  return void 0;
})();
export function useHasSocks() {
  const account = useAccount();
  const shouldCheckSocks = SOCKS && account.chainId === UniverseChainId.Mainnet;
  const balance = useTokenBalance(account.address, shouldCheckSocks ? SOCKS : void 0);
  return useMemo(() => Boolean(balance?.greaterThan(0)), [balance]);
}
